import Joi from 'joi';

// Required: address (full formatted string), city, street, building.
// Everything else is optional (matches the shared CleaningRequest contract).
export const locationPageValidator = Joi.object({
    address: Joi.string().required().allow("").messages({
        // 'string.empty': 'Заповніть це поле',
    }),
    city: Joi.string().required().allow("").messages({
        // 'string.empty': 'Заповніть це поле',
    }),
    street: Joi.string().required().allow("").messages({
        // 'string.empty': 'Заповніть це поле',
    }),
    buildingNumber: Joi.string().required().allow("").messages({
        // 'string.empty': 'Заповніть це поле',
    }),
    apartment: Joi.string().optional().allow(""),
    entrance: Joi.string().optional().allow(""),
    floor: Joi.string().optional().allow(""),
    intercomCode: Joi.string().optional().allow(""),
    postalCode: Joi.string().optional().allow(""),
    comment: Joi.string().optional().allow(""),
});
